module.exports = "/images/Logo.svg?0a9994d224c700e923f5b4190498dbbd";